import { AssignationType } from "@models/ISchema";
import { create } from "zustand";
import { ILeague } from "./ContextVacancies";
import { IErrorWarning } from "@models/Errors/ErrorWarning";
import { InstructorLinkTags } from "@modules/vacancies/Instructor/instructorLinkTags/types";

type AssignationTypeData = AssignationType & {
  courseType: string;
};

type AssignationTypeError = {
  code: string;
  link: ILeague;
  maxAllowed: number;
  error: IErrorWarning;
};

export type InstructorLinkTagsChangeset = {
  instructorLinkId: string;
  linkId: string;
  tags: InstructorLinkTags;
};

export type InstructorLinkTagsError = {
  link: ILeague;
  error: IErrorWarning & { messageAccent?: string };
};

export type InstructorCorrectionValidity = {
  responsibilityValid: boolean;
  primaryValid: boolean;
  primaryCount: number;
  existingRulesValid: boolean;
  valid: boolean;
};

type State = {
  assignationTypesToSave: {
    data: AssignationTypeData;
    instructorId: string;
    instructorLinkId: string;
    linkId: string;
  }[];
  assignationTypesErrors: AssignationTypeError[];
  assignationHaveChanges: boolean;
  allChangesAreValid: boolean;
  instructorLinkTagsToSave: InstructorLinkTagsChangeset[];
  instructorLinkTagsErrors: InstructorLinkTagsError[];
  instructorCorrectionValidityByLink: Record<string, InstructorCorrectionValidity>;
};

export const useVacanciesStore = create<State>(() => ({
  assignationTypesToSave: [],
  assignationTypesErrors: [],
  assignationHaveChanges: false,
  allChangesAreValid: false,
  instructorLinkTagsToSave: [],
  instructorLinkTagsErrors: [],
  instructorCorrectionValidityByLink: {},
}));

export const setInstructorCorrectionValidity = (
  linkId: string,
  validity: InstructorCorrectionValidity | null,
) => {
  useVacanciesStore.setState(state => {
    const next = { ...state.instructorCorrectionValidityByLink };
    if (validity) next[linkId] = validity;
    else delete next[linkId];
    return { instructorCorrectionValidityByLink: next };
  });
};

export const setInstructorLinkTagsToSave = (changesets: InstructorLinkTagsChangeset[]) => {
  useVacanciesStore.setState({ instructorLinkTagsToSave: changesets });
};

export const setInstructorLinkTagsErrors = (errors: InstructorLinkTagsError[]) => {
  useVacanciesStore.setState({ instructorLinkTagsErrors: errors });
};

export const setAssignationTypesToSave = (assignationTypes: State["assignationTypesToSave"]) => {
  useVacanciesStore.setState({ assignationTypesToSave: assignationTypes });
};

export const setAllChangesAreValid = (isValid: boolean) => {
  useVacanciesStore.setState({ allChangesAreValid: isValid });
};

export const setAssignationTypesErrors = (errors: State["assignationTypesErrors"]) => {
  useVacanciesStore.setState({ assignationTypesErrors: errors });
};

export const setAssignationHaveChanges = (haveChanges: boolean) => {
  useVacanciesStore.setState({ assignationHaveChanges: haveChanges });
};
